<template>
	<div
		:class="[
			isPromotedTier ? 'overflow-visible' : 'bg-default z-10',
			'relative bg-default shadow-lg rounded-xl max-w-fit mx-auto'
		]"
	>
		<div
			v-if="isPromotedTier"
			:class="[
				showDetails ? 'scale-x-125 scale-y-[1.1]' : 'scale-x-125 scale-y-[1.35]',
				'absolute blur-md w-full bg-blue-300/15 -z-20 shadow-lg -top-2 h-full rounded-full transform'
			]"
		/>
		<div
			ref="card"
			:class="[
				'relative outline outline-dimmed mx-auto flex flex-col items-center justify-center gap-2 px-8 py-6 text-center rounded-xl min-h-[212px] w-[222px] overflow-visible isolate tranistion-all duration-200 ease-in-out',
				isPromotedTier ? 'border-primary border-b-8 rounded-xl bg-gradient-to-br from-primary/15 to-white' : 'bg-default'
			]"
		>
			<div class="text-primary">
				<p class="flex items-baseline justify-center">
					<span class="text-3xl font-bold tracking-tighter">
						{{ speedWithCommas }}
					</span>
					<span class="ml-1 text-xl font-semibold">
						{{ tier.unit }}
					</span>
				</p>

				<p class="flex items-center justify-center py-2 text-highlighted">
					<span class="text-5xl font-bold tracking-tight">
						${{ tier.price }}
					</span>
					<span class="ml-1 text-xl">
						/{{ tier.frequency }}
					</span>
				</p>
			</div>
			<UButton
				v-if="buttonText"
				color="primary"
				variant="solid"
				:label="buttonText"
				class="h-8 w-full sm:w-44 text-sm font-bold focus:outline-none uppercase"
				@click="setTier"
			/>
			<div
				v-if="showDetails"
				class=""
			>
				<ul
					role="list"
					class="w-56 pt-2 text-left px-2 flex flex-col"
				>
					<li
						v-for="feature in tier.features"
						:key="feature"
						class="flex border-t border-dimmed/60 first:border-t-0 last:border-b-0 items-center gap-3 py-2"
					>
						<UIcon
							name="i-lucide-check"
							class="text-primary flex-shrink-0 w-6 h-6"
							aria-hidden="true"
						/>
						<span class="text-sm text-toned">
							{{ rt(feature) }}
						</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { MappedPackage } from '@/types/components/signup'
import { useI18n } from 'vue-i18n'

const { rt } = useI18n()

const props = defineProps({
	tier: {
		type: Object as PropType<MappedPackage>,
		required: true
	},
	selectedTierIndex: {
		type: Number,
		default: 0
	},
	showDetails: {
		type: Boolean,
		default: false
	},
	buttonText: {
		type: String,
		default: ''
	},
	disableButton: {
		type: Boolean,
		default: false
	}
})

const {
	tier, showDetails
} = toRefs(props)

const card = ref(null)

const emit = defineEmits([ 'setTier' ])
const setTier = () => {
	emit('setTier', tier.value.id)
}

const speedWithCommas = computed(() => {
	return tier.value?.packageSpeed?.toLocaleString() || ''
})

const isPromotedTier = computed(() => {
	return tier.value?.recommended || tier.value?.mostPopular
})
</script>
